import { LifeArea, Locales, LocalizedLifeArea } from '@griply/types';

import { getLocalizedStringValue } from './get-localized-string-value';

export const filterLifeAreasBySearchText = (
  lifeAreas: (LifeArea | LocalizedLifeArea)[],
  searchText: string,
  locale: Locales,
): (LifeArea | LocalizedLifeArea)[] => {
  if (!searchText) {
    return [];
  }
  const trimmedSearchText = searchText.trim().toLowerCase();

  return lifeAreas
    .filter(({ name }) =>
      getLocalizedStringValue(name, locale)
        .toLowerCase()
        .includes(trimmedSearchText),
    )
    .sort((a, b) =>
      getLocalizedStringValue(a.name, locale).localeCompare(
        getLocalizedStringValue(b.name, locale),
      ),
    );
};
